import { Suspense, lazy } from 'react'
import type { RouteMapProps } from './route-map'

// mapbox-gl is ~530 kB gzipped, so it is only fetched once a map is actually
// shown rather than on every page that imports the approval view.
const RouteMap = lazy(() =>
  import('./route-map').then(module => ({ default: module.RouteMap }))
)

export const LazyRouteMap: React.FC<RouteMapProps> = props => (
  <Suspense
    fallback={
      <div
        className={props.className}
        style={{ ...props.style, backgroundColor: 'var(--color-stone-100)' }}
      />
    }
  >
    <RouteMap {...props} />
  </Suspense>
)
